<template>
  <page
    :title="order ? 'Order - #' + order.data.id : ''"
    backTo="/orders"
    :loading="order.loading"
    size="is-desktop"
  >
    <div slot="page-header-right">
<!--      <b-dropdown position="is-bottom-left">-->
<!--        <button class="button" slot="trigger">-->
<!--          <b-icon icon="dots-horizontal"></b-icon>-->
<!--        </button>-->

<!--        <b-dropdown-item >Send a link to reset password</b-dropdown-item>-->
<!--      </b-dropdown>-->
        <button
          class="button is-primary"
          :class="{'is-loading': loading }"
          v-on:click="paymentCheck">
          <b-icon icon="refresh"></b-icon>
          <span>
            <slot>Төлөлт</slot>
          </span>
        </button>
    </div>

    <div class="box" v-if="order.data.user">
      <div class="level">
        <div class="level-left">
          <div class="media" style="align-items: center;">
            <div>
              <div class="title is-5">{{ order.data.user.name }}</div>

              <div class="subtitle">{{ order.data.user.email }}</div>
            </div>
          </div>
        </div>

        <div class="level-right">
          <div class="has-text-right">
            <div style="margin-bottom: 0.5rem;">
              <span class="tag is-success is-medium" v-if="order.data.state === 'paid'">Төлөгдсөн</span>
              <button @click="updateStatus" class="button is-light" v-else>Төлөгдөөгүй</button>
            </div>
            <p class="title is-4 is-marginless">
            </p>
            <p>
              {{ order.data.updated_at |dateTime }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="box is-paddingless">
      <b-tabs>
        <b-tab-item label="Дэлгэрэнгүй">
          <b-table
            class="is-middle"
            detailed
            v-if="order.data.subscriptions"
            :data="order.data.subscriptions"
          >
            <template slot-scope="props">
            <b-table-column label="Бүтээгдэхүүн" width="80">
              {{ props.row.plan.name }}
            </b-table-column>

            <b-table-column label="QPAY Шимтгэл" width="80">
              {{ order.data.total_price /100 }}₮
            </b-table-column>

            <b-table-column label="Орлого" width="80">
              {{ order.data.total_price - order.data.total_price /100 }}₮
            </b-table-column>

              <b-table-column label="Үнэ" width="80">
                {{ order.data.total_price }}₮
              </b-table-column>
            </template>
            <template #detail="props">
              <b-table
                class="is-middle"
                v-if="order.data.issue_activations"
                :data="order.data.issue_activations"
              >
                <template slot-scope="props">
                  <b-table-column label="ID" width="10" class="has-text-weight-bold">
                    {{ props.row.issue.id }}
                  </b-table-column>

                  <b-table-column label="Бүтээгдэхүүн" width="80" class="has-text-weight-bold">
                    {{ props.row.issue.title }}
                  </b-table-column>

                  <b-table-column label="Release Date" width="120">
                    {{ props.row.issue.relaese_date | dateTime }}
                  </b-table-column>
                </template>
              </b-table>
            </template>
          </b-table>

          <b-table
            class="is-middle"
            v-if="order.data.issue_activations && order.data.subscriptions.length === 0"
            :data="order.data.issue_activations"
          >
            <template slot-scope="props">
              <b-table-column label="Бүтээгдэхүүн" width="80" class="has-text-weight-bold">
                {{ props.row.issue.magazine.name }} / {{ props.row.issue.title }}
              </b-table-column>

              <b-table-column label="QPAY Шимтгэл" width="80">
                {{ order.data.total_price /100 }}₮
              </b-table-column>

              <b-table-column label="Орлого" width="80">
                {{ order.data.total_price - order.data.total_price /100 }}₮
              </b-table-column>

              <b-table-column label="Үнэ" width="80">
                {{ order.data.total_price }}₮
              </b-table-column>
            </template>
          </b-table>
        </b-tab-item>
      </b-tabs>
    </div>
  </page>
</template>

<script>

import UpdateStatusModal from "./UpdateStatusModal";

export default {
  data() {
    return {
      tab: 1,
      order: new window.RemoteData(() => {
        return `/admin/api/orders/${this.$route.params.id}`;
      }).load(),
      loading:false
    };
  },

  methods: {
    paymentCheck() {
      this.loading = true;

      this.$http
        .get("/admin/api/orders/" + this.$route.params.id + "/validate", {
          gateway: this.order.data.payment_gateway
        })
        .then(response => {
          this.$buefy.toast.open({
            message: response.data == true ? 'Нэмэмжлэх төлөгдсөн байна' : 'Нэмэмжлэх төлөгдөөгүй байна',
            type: response.data == true ? 'is-success' : 'is-danger'
          })
          this.loading = false;
        }).catch(expection => {
        this.$buefy.toast.open(expection.message)
      })
    },

    updateStatus() {
      this.$buefy.modal.open({
        component: UpdateStatusModal,
        props: {
          order_id: this.order.data.id,
          updated: status => {
            this.order.data.state = status;

            this.order.load();
          }
        }
      });
    }
  }
};
</script>
